const Heading = (props) => {
  const Tag = 'h' + props.level
  return (
    <Tag className={`a-heading is-size-${props.size}`}>
      <span>{props.content ? props.content : props.children}</span>
    </Tag>
  )
}

export default Heading
